import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function HelpAiMethodology() {
  return (
    <CustomerMethodologyPage
      title="In-app Help AI — overview"
      description="How the WeConsult Rx in-app Help drawer uses page context to answer workflow questions."
      path="/trust/help-ai-methodology"
    >
      <p>
        The in-app Help drawer provides contextual assistance based on the page
        you are viewing. It answers workflow questions without accessing resident
        clinical data.
      </p>
      <h2>What it does</h2>
      <ul>
        <li>Explains how to use the current page or feature.</li>
        <li>Links to relevant documentation and trust resources.</li>
        <li>Logs queries for audit without storing raw question text.</li>
      </ul>
      <h2>What it does not do</h2>
      <ul>
        <li>Access or analyze resident charts or clinical data.</li>
        <li>Provide clinical decision support or prescribing advice.</li>
      </ul>
    </CustomerMethodologyPage>
  );
}
